export enum Language {
  RU = "ru",
  EN = "en",
  HY = "hy",
}

export const LANGUAGE_KEY = "lang";

export const languageList = Object.keys(Language).map(
  (key) => Language[key as keyof typeof Language]
);

export type I18nState = {
  selectedLang: Language;
};
